<template>
	<div class="login-main">
		<div class="register-type" v-if="lang === 'zh'">
			<div class="register-box" @click="changeType('gr')" :style="{backgroundColor: registerType === 'gr' ? '#264EA7' : '', color: registerType === 'gr' ? '#FFFFFF' : ''}">
				{{lang == ('zh' || 'young') ? '个人注册' : 'PERSONAL'}}
			</div>
			<div class="register-box" @click="changeType('td')" :style="{backgroundColor: registerType === 'td' ? '#264EA7' : '', color: registerType === 'td' ? '#FFFFFF' : ''}">
				{{lang == ('zh' || 'young') ? '团队注册' : 'GROUP'}}
			</div>
		</div>
		<div v-if="registerType === 'gr'">
			<div class="title">
				<i class="iconfont iconanchor-full"></i>
				<div style="margin: 0 40px;">
					{{lang == ('zh' || 'young') ? '个人注册' : 'PERSONAL REGISTER'}}
				</div>
				<i class="iconfont iconanchor-full"></i>
			</div>
			<Row>
				<Col span="10">
					<div class="input-line">
						{{lang == ('zh' || 'young') ? '手机号码' : 'Phone Number:'}}：
					</div>
					<div class="input-line">
						{{lang == ('zh' || 'young') ? '图片验证码' : 'Image Verification Code'}}：
					</div>
					<div class="input-line">
						{{lang == ('zh' || 'young') ? '短信验证码' : 'SMS Verification Code'}}：
					</div>
					
					<div class="input-line">
						{{lang == ('zh' || 'young') ? '设置密码' : 'Set Password'}}：
					</div>
					<div class="input-line">
						{{lang == ('zh' || 'young') ? '确认密码' : 'Confirm Password'}}：
					</div>
				</Col>
				<Col span="14">
					<div class="input-right">
						<Input style="width: 240px;" v-model="grObj.mobile" maxlength="11"></Input>
						<span style="margin-left: 10px; color: #922627; font-size: 26px;">*</span>
					</div>
					<div class="input-right">
						<Input style="width: 240px;" v-model="grObj.validateCode">
						</Input>
						<span style="margin-left: 10px; color: #922627; font-size: 26px;">*</span>
						<img v-if="imgData" :src="imgData" alt="" style="width: 90px; height: 30px; margin-left: 20px; cursor: pointer;" @click="getImgData">
					</div>
					<div class="input-right">
						<Input style="width: 240px;" placeholder="" v-model="grObj.smsValidateCode">
							<Button @click="sendCode" slot="append" :disabled="!canSend" :style="{backgroundColor: canSend ? '#264EA7' : '#f7f7f7', color: canSend ? '#FFFFFF' : '#c5c8ce'}" style="border-radius: 0; cursor: pointer;">{{canSend ? (lang == ('zh' || 'young') ? '发送验证码' : 'Send') : leftTime + 's'}}</Button>
						</Input>
						<span style="margin-left: 10px; color: #922627; font-size: 26px;">*</span>
					</div>
					
					<div class="input-right">
						<Input style="width: 240px;" v-model="grObj.pwd" type="password"></Input>
						<span style="margin-left: 10px; color: #922627; font-size: 26px;">*</span>
						<span style="margin-left: 20px; color: #AAAAAA; font-size: 9px;">{{lang == ('zh' || 'young') ? '请输入6-18位的密码' : 'Please enter a 6-18 digit password'}}</span>
					</div>
					<div class="input-right">
						<Input style="width: 240px;" v-model="grObj.confirmPwd" type="password"></Input>
						<span style="margin-left: 10px; color: #922627; font-size: 26px;">*</span>
						<span style="margin-left: 20px; color: #AAAAAA; font-size: 9px;">{{lang == ('zh' || 'young') ? '请再次确认密码' : 'Please confirm the password again'}}</span>
					</div>
				</Col>
			</Row>
		</div>

		<div v-if="registerType === 'td'">
			<div class="title">
				<i class="iconfont iconanchor-full"></i>
				<div style="margin: 0 40px;">
					{{lang == ('zh' || 'young') ? '团队注册' : 'GROUP REGISTER'}}
				</div>
				<i class="iconfont iconanchor-full"></i>
			</div>
			<Row>
				<Col span="10">
					<div class="input-line">
						{{lang == ('zh' || 'young') ? '团队名称' : 'Team Name'}}：
					</div>
					<div class="input-line">
						{{lang == ('zh' || 'young') ? '营业执照/组织机构代码证' : 'Business Qualification Certificate'}}：
					</div>
					<div class="input-line" style="margin-top: 318px;">
						{{lang == ('zh' || 'young') ? '真实姓名' : 'Real Name'}}：
					</div>
					<div class="input-line">
						{{lang == ('zh' || 'young') ? '邮箱' : 'Email'}}：
					</div>
					<div class="input-line">
						{{lang == ('zh' || 'young') ? '证件类型' : 'Certificate Type'}}：
					</div>
					<div class="input-line">
						{{lang == ('zh' || 'young') ? '证件号码' : 'ID Number'}}：
					</div>
					<div class="input-line">
						{{lang == ('zh' || 'young') ? '手机号' : 'Phone Number'}}：
					</div>
					<div class="input-line">
						{{lang == ('zh' || 'young') ? '图片验证码' : 'Image Verification Code'}}：
					</div>
					<div class="input-line">
						{{lang == ('zh' || 'young') ? '短信验证码' : 'SMS Verification Code'}}：
					</div>
					
					<div class="input-line">
						{{lang == ('zh' || 'young') ? '设置密码' : 'Set Password'}}：
					</div>
					<div class="input-line">
						{{lang == ('zh' || 'young') ? '确认密码' : 'Confirm Password'}}：
					</div>
				</Col>
				<Col span="14">
					<div class="input-right">
						<Input style="width: 240px;" placeholder="" v-model="tdObj.orgName"></Input>
						<span style="margin-left: 10px; color: #922627; font-size: 26px;">*</span>
					</div>
					<div class="upload-right">
						<div class="upload-top">
							<Upload
								style="background-color: #196EE8; color: #FFFFFF; font-size: 11px; height: 30px; width: 100px; line-height: 30px; margin-top: 5px; cursor: pointer;"
								ref="img_ref"
								:action="$baseUrl + '/sys/accessory/uploadFile'"
								:on-success="successUpload"
								:max-size="10240"
								name="uploadFile">
								{{lang == ('zh' || 'young') ? '选择文件' : 'Choose File'}}
							</Upload>
							<span style="margin-left: 10px; color: #922627; font-size: 26px;">*</span>
						</div>
						<div class="upload-text" v-if="lang == ('zh' || 'young')">
							旅行社请提供“营业执照（盖公章）”，机关部委 或企事业
							<p>
								单位和学校请提供“组织机构代码证（盖公章）”。图片宽和高需大于
							</p>
							<p>
								460px*460px且大于50k小于600k。
							</p>
							<p>
								注：团队人数20人以上（含20人）、100人以下（含100人）方可预约。）
							</p>
						</div>
						<div class="upload-text" v-else>
							Please provide "business license (with official seal)" for travel agency and "letter of Introduction (with official seal)" for
							<p>
								departments,ministries,enterprises,institutions and schools.The width and height of the image should be greater than 460px
							</p>
							<p>
								* 460pxand greater than 50K and less than 600k.(Note: the appointment can only be made if the team has more than 20
							</p>
							<p>
								people (including 20 people) and less than 500 people (including 500 people)
							</p>
						</div>
						<div class="upload-img">
							<img :src="$imgUrl + tdObj.imgs" alt="" v-if="tdObj.imgs">
						</div>
					</div>
					<div class="input-right">
						<Input style="width: 240px;" placeholder="" v-model="tdObj.name"></Input>
						<span style="margin-left: 10px; color: #922627; font-size: 26px;">*</span>
					</div>
					<div class="input-right">
						<Input style="width: 240px;" placeholder="" type="email" v-model="tdObj.email"></Input>
						<span style="margin-left: 10px; color: #922627; font-size: 26px;">*</span>
					</div>
					<div class="input-right">
						<Select v-model="tdObj.cardType" style="width: 240px;">
							<Option v-for="(item, index) in cardTypeList" :value="item.value" :key="item.value">
								{{lang == ('zh' || 'young') ? item.label : item.enLabel}}
							</Option>
						</Select>
						<span style="margin-left: 10px; color: #922627; font-size: 26px;">*</span>
					</div>
					<div class="input-right">
						<Input style="width: 240px;" placeholder="" v-model="tdObj.idNumber"></Input>
						<span style="margin-left: 10px; color: #922627; font-size: 26px;">*</span>
					</div>
					<div class="input-right">
						<Input style="width: 240px;" placeholder="" type="tel" v-model="tdObj.mobile" maxlength="11"></Input>
						<span style="margin-left: 10px; color: #922627; font-size: 26px;">*</span>
					</div>
					<div class="input-right">
						<Input style="width: 240px;" placeholder="" v-model="tdObj.validateCode">
						</Input>
						<span style="margin-left: 10px; color: #922627; font-size: 26px;">*</span>
						<img v-if="imgData" :src="imgData" alt="" style="width: 90px; height: 30px; margin-left: 20px; cursor: pointer;" @click="getImgData">
					</div>
					<div class="input-right">
						<Input style="width: 240px;" placeholder="" v-model="tdObj.smsValidateCode">
							<Button @click="sendCode" slot="append" :disabled="!canSend" :style="{backgroundColor: canSend ? '#264EA7' : '#f7f7f7', color: canSend ? '#FFFFFF' : '#c5c8ce'}" style="border-radius: 0; cursor: pointer;">{{canSend ? (lang == ('zh' || 'young') ? '发送验证码' : 'Send') : leftTime + 's'}}</Button>
						</Input>
						<span style="margin-left: 10px; color: #922627; font-size: 26px;">*</span>
					</div>
					
					<div class="input-right">
						<Input style="width: 240px;" placeholder="" v-model="tdObj.pwd" type="password"></Input>
						<span style="margin-left: 10px; color: #922627; font-size: 26px;">*</span>
						<span style="margin-left: 20px; color: #AAAAAA; font-size: 9px;">{{lang == ('zh' || 'young') ? '请输入6-18位的密码' : 'Please enter a 6-18 digit password'}}</span>
					</div>
					<div class="input-right">
						<Input style="width: 240px;" placeholder="" v-model="tdObj.confirmPwd" type="password"></Input>
						<span style="margin-left: 10px; color: #922627; font-size: 26px;">*</span>
						<span style="margin-left: 20px; color: #AAAAAA; font-size: 9px;">{{lang == ('zh' || 'young') ? '请再次确认密码' : 'Please confirm the password again'}}</span>
					</div>

				</Col>
			</Row>
		</div>

		<div class="login-button" @click="register">
			{{lang == ('zh' || 'young') ? '确认' : 'Register'}}
		</div>
		<div style="margin-top: 20px; font-size: 12px; text-align: center;">
			{{lang == ('zh' || 'young') ? '已有账号' : 'Had account'}}？<span style="margin-left: 5px; color: #264EA7; cursor: pointer;" @click="toLogin">{{lang == ('zh' || 'young') ? '立即登录' : 'Login now'}}</span>
		</div>
	</div>
</template>

<script>
	export default {
		name: '',
		data () {
			return {
				grObj: {
					mobile: '',
					validateCode: '',
					smsValidateCode: '',
					pwd: '',
					confirmPwd: ''
				},
				tdObj: {
					cardType: 'ID_CAR'
				},
				registerType: 'gr',
				imgData: "",
				canSend: true,
				leftTime: 60,
				intervalID: "",
				uuid: "",
				cardTypeList: [
					{
						label: '第二代居民身份证',
						enLabel: 'ID Card',
						value: 'ID_CARD'
					},
					{
						label: '护照',
						enLabel: 'Passport',
						value: 'PASSPORT'
					},
					{
						label: '台胞证',
						enLabel: 'Taiwan Card',
						value: 'TAIWAN_CARD'
					},
					{
						label: '外国永久居留身份证',
						enLabel: 'Green Card',
						value: 'GREEN_CARD'
					},
					{
						label: '港澳台居民居住证',
						enLabel: 'Hk Macao Tai Card',
						value: 'HK_M_T_CARD'
					}
				]
			}
		},
		mounted() {
			this.getImgData()
		},
		computed: {
			lang() {
				return this.$store.state.lang
			}
		},
		methods: {
			encryptByDES(str){
				const key = 'WfJTKO9S4eLkrPz2JKrAnzdb'
				const iv = 'D076D35C'
				var cryptoKey = this.$CryptoJS.enc.Utf8.parse(key)
				var cryptoIv = this.$CryptoJS.enc.Utf8.parse(iv.substr(0, 8))
				var encodeStr = this.$CryptoJS.TripleDES.encrypt(str, cryptoKey, {
				    iv: cryptoIv,
				    mode: this.$CryptoJS.mode.CBC,
				    padding: this.$CryptoJS.pad.Pkcs7
				})
				return encodeStr.toString()
			},
			successUpload(res) {
				console.log(res);
				if(res.code === 'S200') {
					this.tdObj.imgs = res.data.id
					this.$forceUpdate()
				}
			},
			getImgData() {
				let that = this
				let url = '/api/user/getImageValidateCodeAndKey'
				if(that.lang == 'en') {
					url = '/api/en/user/getImageValidateCodeAndKey'
				}
				that.$http.post({
					url: url,
					data: {}
				}).then(res => {
					if(res.code === 'S200') {
						that.imgData = "data:image/png;base64," + res.data.code
						that.uuid = res.data.key
					} else {
						that.$Message.error(res.msg)
					}
				})
			},
			changeType(chooseType) {
				if(this.registerType === chooseType) {
					return
				}
				this.grObj = {
					mobile: '',
					validateCode: '',
					smsValidateCode: '',
					pwd: '',
					confirmPwd: ''
				}
				this.tdObj = {
					cardType: 'ID_CARD'
				}
				this.getImgData()
				this.canSend = true
				this.intervalID = ''
				this.leftTime = 60
				this.registerType = chooseType
			},
			sendCode() {
				let that = this
				var mobile = ''
				var validateCode=''
				if(that.registerType === 'gr') {
					mobile = that.grObj.mobile
					validateCode=that.grObj.validateCode
				} else {
					mobile = that.tdObj.mobile
					validateCode=that.tdObj.validateCode
				}
				if(!mobile) {
					var message = this.lang == ('zh' || 'young') ? '请输入手机号码' : 'Please type your phone number'
					that.$Message.error(message)
					return
				}
				
               if(!validateCode) {
						var message = this.lang == ('zh' || 'young') ? '请输入图片验证码' : 'Please type image verification'
						that.$Message.error(message)
						return
			    }

				let url = '/api/sms/sendValidateCodeV2'
				that.$http.post({
					url: url,
					data: {
						mobile: mobile,
						validateCode:validateCode,
						uuid:that.uuid

					}
				}).then(res => {
					if(res.code === 'S200') {
						if(that.lang === 'zh') {
							that.$Message.success('发送成功')
						} else {
							that.$Message.success('Send success.')
						}
						that.canSend = false
						that.leftTime = 60
						that.intervalID = setInterval(() => that.startInterval(), 1000)
					} else {
						that.$Message.error(res.msg)
					}
				})
			},
			startInterval() {
				let that = this
				if(that.leftTime == 0) {
					clearInterval(that.intervalID)
					that.canSend = true
				} else {
					that.leftTime --
				}
			},
			register() {
				let that = this
				if(that.registerType == 'gr') {
					if(!that.grObj.mobile) {
						var message = this.lang == ('zh' || 'young') ? '请输入手机号码' : 'Please type your phone number'
						that.$Message.error(message)
						return
					}
					if(that.grObj.mobile.length != 11) {
						var message = this.lang == ('zh' || 'young') ? '请输入手机号码' : 'Please type your phone number'
						that.$Message.error(message)
						return
					}
					if(!that.grObj.pwd || !that.grObj.confirmPwd) {
						var message = this.lang == ('zh' || 'young') ? '请输入密码' : 'Please type your password'
						that.$Message.error(message)
						return
					}
					if(that.grObj.pwd != that.grObj.confirmPwd) {
						var message = this.lang == ('zh' || 'young') ? '两次密码输入不一致，请再次确认' : 'The entered passwords are inconsistent'
						that.$Message.error(message)
						return
					}
					if(!that.grObj.validateCode) {
						var message = this.lang == ('zh' || 'young') ? '请输入图片验证码' : 'Please type image verification'
						that.$Message.error(message)
						return
					}
					let url = '/api/user/register'
					if(that.lang == 'en') {
						url = '/api/en/user/register'
					}
					var pwd = this.encryptByDES(that.grObj.pwd)
					that.$http.post({
						url: url,
						data: {
							mobile: that.grObj.mobile,
							validateCode: that.grObj.validateCode,
							smsValidateCode: that.grObj.smsValidateCode,
							pwd: pwd,
							uuid: that.uuid
						}
					}).then(res => {
						if(res.code === 'S200') {
							that.$Message.success('注册成功！')
							if(that.$route.query.redirect) {
								this.$router.push({
									path: '/login',
									query: {
										redirect: that.$route.query.redirect
									}
								})
							} else {
								that.$router.push('login')
							}
						} else {
							that.$Message.error(res.msg)
							that.getImgData()
						}
					})
				} else {
					if(!that.tdObj.orgName) {
						var message = this.lang == ('zh' || 'young') ? '请输入团队名称' : 'Please type team name'
						that.$Message.error(message)
						return
					}
					if(!that.tdObj.imgs) {
						var message = this.lang == ('zh' || 'young') ? '请输入团队名称' : 'Please upload the qualification picture'
						that.$Message.error(message)
						return
					}
					if(!that.tdObj.name) {
						var message = this.lang == ('zh' || 'young') ? '请输入真实姓名' : 'Please input real name'
						that.$Message.error(message)
						return
					}
					if(!that.tdObj.idNumber) {
						var message = this.lang == ('zh' || 'young') ? '请输入身份证号码' : 'Please input card no'
						that.$Message.error(message)
						return
					}
					if(!that.tdObj.email) {
						var message = this.lang == ('zh' || 'young') ? '请输入邮箱地址' : 'Please input email'
						that.$Message.error(message)
						return
					}
					var myreg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/

					if(!myreg.test(that.tdObj.email)) {
						var message = this.lang == ('zh' || 'young') ? '请输入正确的邮箱格式' : 'Please input correct email'
						that.$Message.error(message)
						return
					}
					if(!that.tdObj.mobile) {
						var message = this.lang == ('zh' || 'young') ? '请输入手机号码' : 'Please type your phone number'
						that.$Message.error(message)
						return
					}
					if(!that.tdObj.pwd || !that.tdObj.confirmPwd) {
						var message = this.lang == ('zh' || 'young') ? '请输入密码' : 'Please type your password'
						that.$Message.error(message)
						return
					}
					if(that.tdObj.pwd != that.tdObj.confirmPwd) {
						var message = this.lang == ('zh' || 'young') ? '两次密码输入不一致，请再次确认' : 'The entered passwords are inconsistent'
						that.$Message.error(message)
						return
					}
					if(!that.tdObj.validateCode) {
						var message = this.lang == ('zh' || 'young') ? '请输入图片验证码' : 'Please type image verification'
						that.$Message.error(message)
						return
					}
					let url = '/api/userOrg/register'
					if(that.lang == 'en') {
						url = '/api/en/userOrg/register'
					}
					var pwd = this.encryptByDES(that.tdObj.pwd)
					that.$http.post({
						url: url,
						data: {
							mobile: that.tdObj.mobile,
							validateCode: that.tdObj.validateCode,
							smsValidateCode: that.tdObj.smsValidateCode,
							pwd: pwd,
							orgName: that.tdObj.orgName,
							imgs: that.tdObj.imgs,
							name: that.tdObj.name,
							idNumber: that.tdObj.idNumber,
							email: that.tdObj.email,
							uuid: that.uuid,
							certificateType: that.tdObj.cardType
						}
					}).then(res => {
						if(res.code === 'S200') {
							that.$Message.success('注册成功！')
							if(that.$route.query.redirect) {
								this.$router.push({
									path: '/login',
									query: {
										redirect: that.$route.query.redirect
									}
								})
							} else {
								that.$router.push('login')
							}
						} else {
							that.$Message.error(res.msg)
							that.getImgData()
						}
					})
				}

			},
			toLogin() {
				let that = this
				if(that.$route.query.redirect) {
					this.$router.push({
						path: '/login',
						query: {
							redirect: that.$route.query.redirect
						}
					})
				} else {
					that.$router.push('login')
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	.login-main {
		width: 80%;
		margin: 80px 10%;
		.register-type {
			width: 40%;
			height: 30px;
			margin: 0 30% 20px;
			display: flex;
			.register-box {
				width: 50%;
				height: 30px;
				text-align: center;
				border: 1px solid #264EA7;
				line-height: 30px;
				font-size: 15px;
				cursor: pointer;
			}
		}
		.title {
			display: flex;
			height: 80px;
			line-height: 80px;
			font-size: 15px;
			color: #264EA7;
			text-align: center;
			justify-content: center;
			i {
				font-size: 17px;
				color: #F8C822;
			}
		}
		.input-line {
			height: 30px;
			line-height: 30px;
			text-align: right;
			color: #686868;
			font-size: 15px;
			margin-top: 20px;
		}
		.input-right {
			height: 30px;
			line-height: 30px;
			font-size: 15px;
			margin-top: 20px;
			display: flex;
		}
		.login-button {
			width: 110px;
			height: 30px;
			line-height: 30px;
			text-align: center;
			background-color: #264EA7;
			color: #FFFFFF;
			margin: 40px auto 0;
			cursor: pointer;
		}
		.upload-right {
			.upload-top {
				margin-top: 20px;
				display: flex;
				.upload-top-left {
					height: 30px;
					line-height: 30px;
					text-align: center;
					background-color: #264EA7;
					color: #FFFFFF;
					width: 120px;
					font-size: 13px;
					cursor: pointer;
				}
			}
			.upload-text {
				margin-top: 10px;
				font-size: 11px;
				color: #686868;
				text-align: left;
				line-height: 20px;
			}
			.upload-img {
				margin-top: 10px;
				height: 190px;
				width: 310px;
				background-color: #D3D3D3;
				img {
					height: 100%;
					width: 100%;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/login/register.vue